import {
    FETCH_DEMO_REQUESTS_REQUEST,
    FETCH_DEMO_REQUESTS_SUCCESS,
    FETCH_DEMO_REQUESTS_FAILURE
} from "../actions/demoActions";

const initialState = {
    demoRequestList: [],
    isLoading: false,
    error: null
};

export const demoRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DEMO_REQUESTS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_DEMO_REQUESTS_SUCCESS:
            return { ...state, demoRequestList: action.payload, isLoading: false };

        case FETCH_DEMO_REQUESTS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        default:
            return state;
    }
};